import MpBaseWidget from '../../MpBaseWidget.js';

export default class MpAjaxUploader extends MpBaseWidget {

	/** @type {string} */
	static NAME = 'MpAjaxUploader';

	/**
	 * @type {DynamicWidgetConfig}
	 */
	static config = {
		name: 'ajax-uploader', // must match the parent folder name
		optionsDataName: 'ajaxUploader', // js data name
		selector: 'div[data-ajax-uploader], section[data-ajax-uploader]', // css selector
		sideEffects: false,
		allowReInit: true,
	};

	/**
	 * @param {JQuery} $element
	 */
	static addCustomHandlersBefore($element) {
		// Disable the custom handlers for the Uppy uploader
	}

	/**
	 * @param {JQuery} $element
	 */
	static removeCustomHandlersBefore($element) {
		// Disable the custom handlers for the Uppy uploader
	}
}
